import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useRouter} from '@s-ui/react-router'

import {BASE_CLASS, NOTIFICATIONS} from './config.js'
import {Notification} from './notification.js'

const NotificationsDealerFavorite = ({showNotification = NOTIFICATIONS.EMPTY}) => {
  const router = useRouter()
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {USER_NOT_LOGGED_IN_USER_ERROR} = config.get('ERRORS')
  const {PATHS} = config.get('paths')

  const [notification, setNotification] = useState(showNotification)

  useMount(() => {
    // Add dealer favorite handlers
    const onAddDealerSuccess = () => {
      setNotification(NOTIFICATIONS.SUCCESS)
    }
    const onAddDealerError = error => {
      if (!(error instanceof USER_NOT_LOGGED_IN_USER_ERROR)) setNotification(NOTIFICATIONS.ERROR)
    }

    // Delete dealer favorite handlers
    const onDeleteDealerSuccess = () => {
      setNotification(NOTIFICATIONS.SUCCESS_DELETE)
    }
    const onDeleteDealerError = error => {
      if (!(error instanceof USER_NOT_LOGGED_IN_USER_ERROR)) setNotification(NOTIFICATIONS.ERROR_DELETE)
    }

    // Subscribe to all use cases
    const _addDealerFavorite$ = domain.get('add_user_favorites_dealer_use_case').subscribe(({result: [error]}) => {
      if (error) onAddDealerError(error)
      else onAddDealerSuccess()
    })
    const _deleteDealerFavorite$ = domain
      .get('delete_user_favorites_dealer_use_case')
      .subscribe(({result: [error]}) => {
        if (error) onDeleteDealerError(error)
        else onDeleteDealerSuccess()
      })

    // Cleanup all subscriptions
    return () => {
      _addDealerFavorite$?.dispose?.()
      _deleteDealerFavorite$?.dispose?.()
    }
  })

  const _handleOnCloseNotification = () => {
    setNotification(NOTIFICATIONS.EMPTY)
  }

  const _onClickButton = () => {
    router.push(PATHS.FAVORITES_LIST_DEALERS)
  }

  return (
    <>
      {notification !== NOTIFICATIONS.EMPTY && (
        <div className={BASE_CLASS}>
          <Notification onClose={_handleOnCloseNotification} onClickButton={_onClickButton} type={notification} />
        </div>
      )}
    </>
  )
}

NotificationsDealerFavorite.displayName = 'NotificationsDealerFavorite'

NotificationsDealerFavorite.propTypes = {
  showNotification: PropTypes.oneOf([
    NOTIFICATIONS.EMPTY,
    NOTIFICATIONS.ERROR,
    NOTIFICATIONS.ERROR_DELETE,
    NOTIFICATIONS.SUCCESS,
    NOTIFICATIONS.SUCCESS_DELETE
  ])
}

export {NOTIFICATIONS}
export default NotificationsDealerFavorite
